import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean, FctBps, FctDecimals, FctValue } from '../../../../Fct/generics';
import { getRadiantV2Tokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { PROTOCOL_DATA_PROVIDER_ADDRESSES } from '../constants';
export var GetReserveConfigurationData = createPlugin({
    protocol: 'RADIANTV2',
    type: 'GETTER',
    method: 'getReserveConfigurationData',
    supportedContracts: PROTOCOL_DATA_PROVIDER_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'radiant_protocol_data_provider_v2' }),
                methodParams: {
                    asset: new FctAddress({ destination: 'erc20', options: getRadiantV2Tokens({ chainId: chainId }) }),
                },
            },
            output: {
                decimals: new FctDecimals({ innerIndex: 0 }),
                ltv: new FctBps({ innerIndex: 1 }),
                liquidationThreshold: new FctBps({ innerIndex: 2 }),
                liquidationBonus: new FctValue({ innerIndex: 3 }),
                reserveFactor: new FctValue({ innerIndex: 4 }),
                usageAsCollateralEnabled: new FctBoolean({ innerIndex: 5 }),
                borrowingEnabled: new FctBoolean({ innerIndex: 6 }),
                stableBorrowRateEnabled: new FctBoolean({ innerIndex: 7 }),
                isActive: new FctBoolean({ innerIndex: 8 }),
                isFrozen: new FctBoolean({ innerIndex: 9 }),
            },
        });
    },
});
